import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = { class: "breadcrumb-wrapper" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "input-row" }
const _hoisted_5 = { class: "input-wr" }
const _hoisted_6 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_7 = { class: "input-wr" }
const _hoisted_8 = { class: "input-row" }
const _hoisted_9 = { class: "input-wr" }
const _hoisted_10 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_11 = { class: "input-wr" }
const _hoisted_12 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_13 = { class: "input-row" }
const _hoisted_14 = { class: "input-wr" }
const _hoisted_15 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_16 = { class: "input-wr" }
const _hoisted_17 = { class: "input" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Breadcrumbs"], {
        crumbs: $setup.crumbs,
        backButton: true
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", {
        class: "default-form",
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { class: "label" }, "First Name", -1)),
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["input", { error: $setup.v$.firstName.$error }]),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.firstName) = $event)),
              type: "text",
              placeholder: "First Name"
            }, null, 2), [
              [_vModelText, $setup.form.firstName]
            ]),
            ($setup.v$.firstName.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.v$.firstName.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { class: "label" }, "Last Name", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.lastName) = $event)),
              type: "text",
              placeholder: "Last Name"
            }, null, 512), [
              [_vModelText, $setup.form.lastName]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { class: "label" }, "Phone", -1)),
            _createVNode($setup["Cleave"], {
              class: _normalizeClass(["input", { error: $setup.v$.phone.$error }]),
              modelValue: $setup.form.phone,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.phone) = $event)),
              options: $setup.phoneNumberOption($setup.form.phone),
              placeholder: "0412 345 678"
            }, null, 8, ["modelValue", "options", "class"]),
            ($setup.v$.phone.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.v$.phone.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "label" }, "Postcode", -1)),
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["input", { error: $setup.v$.postcode.$error }]),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.postcode) = $event)),
              type: "text",
              maxlength: "4",
              placeholder: "e.g. 2000"
            }, null, 2), [
              [_vModelText, $setup.form.postcode]
            ]),
            ($setup.v$.postcode.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString($setup.v$.postcode.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { class: "label" }, "Email", -1)),
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["input", { error: $setup.v$.email.$error }]),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.email) = $event)),
              type: "email",
              placeholder: "Email"
            }, null, 2), [
              [_vModelText, $setup.form.email]
            ]),
            ($setup.v$.email.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString($setup.v$.email.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "label" }, "Buyer Type", -1)),
            _createVNode($setup["DropDown"], null, {
              control: _withCtx(() => [
                _createElementVNode("span", _hoisted_17, _toDisplayString($setup.form.holderType), 1)
              ]),
              dropdown: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([$setup.HolderType.INVESTOR, $setup.HolderType.OWNER_OCCUPIER, $setup.HolderType.FIRST_HOME_BUYER], (holder) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: _normalizeClass(["dropdown__item", { 'dropdown__item-active': holder === $setup.form.holderType }]),
                      key: holder,
                      onClick: ($event: any) => ($setup.form.holderType = holder)
                    }, _toDisplayString(holder), 11, _hoisted_18))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("button", {
            class: "button default primary",
            onClick: $setup.save
          }, "Save Changes"),
          _createVNode(_component_router_link, {
            class: "button default cancel",
            to: { name: 'LeadDetails', params: { id: $setup.leadId } }
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          }, 8, ["to"])
        ])
      ], 32)
    ])
  ]))
}